// Glidejs
import Glide from "@glidejs/glide";
window.Glide = Glide;

import "bootstrap/js/dist/accordion";
import "@fancyapps/fancybox";

$('[data-fancybox="gallery"]').fancybox({
  loop: true,
  wheel: false,
});

const carousel = new Glide(".glide", {
  type: "carousel",
  startAt: 0,
  gap: 0,
  perView: 3,
  autoplay: 3000,

  breakpoints: {
    1324: {
      perView: 3,
    },
    1100: {
      perView: 2,
    },
    700: {
      perView: 1,
    },
  },
});
carousel.mount();
